module.exports = __webpack_public_path__ + "logo-reputation-pro.be75a76c99454176ab9e.svg";